import createReducer from '../../helpers/CreateReducer';
import { ApiConstants } from '../../constants/actions';
import { DeliveryMethods } from '../../constants/deliveryMethods';

import { IDelivery } from '@epi-models/components/BenefitSummary';

interface VoucherOrder {
  delivery?: IDelivery;
  [key: string]: any;
}

interface VoucherOrderState {
  voucherOrder: VoucherOrder | Record<string, never>;
  paymentId: string;
  isLoaded: boolean;
  isError: boolean;
  noPersistance: boolean;
}

export const getInitialState = (): VoucherOrderState => ({
  voucherOrder: {},
  paymentId: '',
  isLoaded: false,
  isError: false,
  noPersistance: true
});

const renameAddressProperty = (voucherOrder: VoucherOrder): VoucherOrder => {
  const delivery = voucherOrder.delivery || ({} as IDelivery);
  if (delivery.method === DeliveryMethods.ToOtherAddress) {
    return {
      ...voucherOrder,
      delivery: {
        ...delivery,
        custom_address: delivery.address,
        address: undefined
      }
    };
  }
  return voucherOrder;
};

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_VOUCHER_ORDER_BY_PAYMENT}_REQUEST`]:
    (): Partial<VoucherOrderState> => ({
      voucherOrder: {},
      paymentId: '',
      isLoaded: false,
      isError: false
    }),

  [`${ApiConstants.LOAD_VOUCHER_ORDER_BY_PAYMENT}_SUCCESS`]: (
    state: VoucherOrderState,
    {
      payload: { paymentId, voucherOrder }
    }: { payload: { paymentId: string; voucherOrder: VoucherOrder } }
  ): Partial<VoucherOrderState> => ({
    voucherOrder: renameAddressProperty(voucherOrder),
    paymentId,
    isLoaded: true,
    isError: false
  }),

  [`${ApiConstants.LOAD_VOUCHER_ORDER_BY_PAYMENT}_FAILURE`]:
    (): Partial<VoucherOrderState> => ({
      voucherOrder: {},
      paymentId: '',
      isLoaded: true,
      isError: true
    })
});
